import React from 'react';
import { motion } from 'framer-motion';

export default function ServiceList({ services, onSelect }) {
  if (!services || services.length === 0) {
    return (
      <div className="p-4 text-center">
        <div className="flex items-center justify-center w-10 h-10 mx-auto mb-3 bg-gray-100 dark:bg-[#1A1A1A] rounded-full">
          <svg className="w-5 h-5 text-gray-400 dark:text-[#666666]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p className="text-sm text-gray-500 dark:text-[#666666]">No services found</p>
        <p className="text-xs text-gray-400 dark:text-[#666666] mt-1">Add services to your profile to get started</p>
      </div>
    );
  }

  return (
    <div className="py-2 max-h-60 overflow-y-auto">
      {services.map((service, index) => (
        <motion.div
          key={service.name}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
          whileHover={{ x: 4 }}
          onClick={() => onSelect(service)}
          className="group relative mx-2 mb-1 last:mb-0 px-4 py-3 rounded-xl hover:bg-gray-50 dark:hover:bg-[#1A1A1A] cursor-pointer transition-all duration-200"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              {/* Service Icon */}
              <div className="w-8 h-8 bg-gradient-to-br from-brand to-[#FF9D5C] rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              
              {/* Service Info */}
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm text-gray-900 dark:text-white truncate">
                  {service.name}
                </div>
                {service.description && (
                  <div className="text-xs text-gray-500 dark:text-[#666666] truncate">
                    {service.description}
                  </div>
                )}
              </div>
            </div>
            
            {/* Price and Arrow */}
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <div className="font-semibold text-sm text-gray-900 dark:text-white">
                  {service.currency} {service.price}
                </div>
                {service.billingType && (
                  <div className="text-xs text-gray-500 dark:text-[#666666]">
                    per {service.billingType}
                  </div>
                )}
              </div>
              
              {/* Arrow indicator */}
              <svg className="w-4 h-4 text-gray-400 dark:text-[#666666] group-hover:text-brand transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
          
          {/* Hover indicator */}
          <div className="absolute inset-0 rounded-xl border border-transparent group-hover:border-brand/20 transition-colors pointer-events-none" />
        </motion.div>
      ))}
    </div>
  );
}